export default class DevelopmentHelper {

  static isDevelopment() {
    return window.location.href.indexOf("laklapjap") >= 0;
  }

}